"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StudySnapshotType = exports.StudySnapshotStatus = void 0;
var StudySnapshotStatus;
(function (StudySnapshotStatus) {
    StudySnapshotStatus["Requested"] = "REQUESTED";
    StudySnapshotStatus["Generating"] = "GENERATING";
    StudySnapshotStatus["Done"] = "DONE";
    StudySnapshotStatus["Failed"] = "FAILED";
})(StudySnapshotStatus = exports.StudySnapshotStatus || (exports.StudySnapshotStatus = {}));
var StudySnapshotType;
(function (StudySnapshotType) {
    StudySnapshotType["CustomDataCrf"] = "CUSTOM_DATA_CRF";
})(StudySnapshotType = exports.StudySnapshotType || (exports.StudySnapshotType = {}));
//# sourceMappingURL=studySnapshot.js.map